module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-BoldItalic-1c9d53ac.ttf";